// MuseIQ Visual Assist - Type Definitions
// Types for piano keyboard and other visual learning aids

// ============================================
// Piano Keyboard MIDI Constants
// ============================================

/** MIDI note number for A0 (lowest key on 88-key piano) */
export const MIDI_A0 = 21;

/** MIDI note number for C8 (highest key on 88-key piano) */
export const MIDI_C8 = 108;

/** Common keyboard ranges */
export const KEYBOARD_RANGES = {
    /** 88-key grand piano: A0-C8 */
    PIANO_88: { start: 21, end: 108 },
    /** 76-key keyboard: E1-G7 */
    KEYBOARD_76: { start: 28, end: 103 },
    /** 61-key keyboard: C2-C7 */
    KEYBOARD_61: { start: 36, end: 96 },
} as const;

// ============================================
// Types
// ============================================

/**
 * Color used to highlight a key based on which hand/staff plays it
 * - 'orange': Treble clef / right hand
 * - 'purple': Bass clef / left hand
 * - 'blue': MIDI input (user-played notes)
 */
export type HighlightColor = 'purple' | 'orange' | 'blue';

/**
 * Information about a highlighted key
 */
export interface KeyHighlight {
    /** MIDI note number (21-108 for 88-key piano) */
    midiNote: number;
    /** Color indicating which hand/staff */
    color: HighlightColor;
    /** Fingering number 1-5, or null if not specified */
    fingering: number | null;
    /** Whether this is a faded highlight (for next beat notes) */
    faded?: boolean;
}

/**
 * Note information extracted from alphaTab
 */
export interface ActiveNoteInfo {
    /** MIDI pitch from note.realValue */
    midiNote: number;
    /** Staff index: 0=treble/right, 1=bass/left */
    staffIndex: number;
    /** Track index this note belongs to */
    trackIndex: number;
    /** Fingering from note.leftHandFinger or note.rightHandFinger */
    fingering: number | null;
}
